import React from 'react';
import { useSelector } from 'react-redux';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import { FeedbackMessages } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import { Preloader } from '../../shared/svg/components';

const ServerApiPopup = () => {
  const isSavingConfiguration = useSelector(state => state.configurator.isSavingConfiguration);
  const isDownloadingPdf = useSelector(state => state.configurator.isDownloadingPdf);
  const isRequestingBudget = useSelector(state => state.configurator.isRequestingBudget);
  const saveConfigurationMutation = SaveConfigurationService();

  const getMessage = () => {
    let message = TranslationUtility.GetFormattedMessageForUI('ui-feedback-saving-configuration',
        FeedbackMessages.SavingConfiguration);

    if (isSavingConfiguration) {
      if (saveConfigurationMutation.isLoading) {
        message = TranslationUtility.GetFormattedMessageForUI('ui-feedback-loading',
            FeedbackMessages.Loading);
      }
      if (saveConfigurationMutation.isError) {
        message = TranslationUtility.GetFormattedMessageForUI('ui-feedback-error-saving-configuration',
            FeedbackMessages.ErrorSavingConfiguration);
      }
    }

    if (isRequestingBudget) {
      message = TranslationUtility.GetFormattedMessageForUI('ui-feedback-requesting-budget',
          FeedbackMessages.RequestingBudget);
    }

    return message;
  };

  if (isSavingConfiguration || isRequestingBudget) {
    return (
      <div className="server-api-popup">
        <div className="container-message">
          <div className="message">{getMessage()}</div>
        </div>
      </div>
    );
  }

  if (isDownloadingPdf) {
    return (
      <div className="generate-pdf-overlay-background">
        <div className="container-loader">
          <Preloader className="icon" />
        </div>
        <div className="generate-pdf-title">
          {TranslationUtility.GetFormattedMessageForUI('ui-feedback-generating-pdf',
                FeedbackMessages.GeneratingPdf)}
        </div>
        <div className="generate-pdf-subtitle">
          {TranslationUtility.GetFormattedMessageForUI('ui-feedback-generating-pdf-subtitle',
                FeedbackMessages.GeneratingPdfSubtitle)}
        </div>
      </div>
    );
  }

  return null;
};

export default ServerApiPopup;
